import { useEffect, useState } from "react";
import { FROM_KEY, ORDER_KEY, PAGE_KEY, PAGE_SIZE_KEY, SORT_KEY, TO_KEY } from "../utils/const";

export const useQueryParams = () => {
  const getParams = () => {
    const params = new URLSearchParams(window.location.search);
    return {
      page: Number(params.get(PAGE_KEY))|| 1,
      pageSize: Number(params.get(PAGE_SIZE_KEY)) || 10,
      sort: params.get(SORT_KEY) || "",
      order: params.get(ORDER_KEY) || "",
      filters: Object.fromEntries([...params.entries()].filter(([key]) => ![PAGE_KEY, PAGE_SIZE_KEY, SORT_KEY, ORDER_KEY].includes(key))),
      from: Number(params.get(FROM_KEY))|| 1,
      to: Number(params.get(TO_KEY))|| 10
    };
  };

  const [queryParams, setQueryParams] = useState(getParams);

  useEffect(() => {
    const handlePopState = () => {
      setQueryParams(getParams());
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return queryParams;
};
